import styled from 'styled-components';

export const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 16px;
  justify-content: center;
`;

export const CarouselContainer = styled.div<{
  $height?: string;
  $width?: string;
}>`
  position: relative;
  width: 100%;
  max-width: ${({ $width }) => $width || '500px'};
  max-height: ${({ $height }) => $height || '100%'};
  aspect-ratio: 5/6;
  border-radius: 16px;
  overflow: visible;
  background: transparent;

  .ant-carousel .slick-list {
    border-radius: 16px;
    overflow: hidden;
    background: transparent;
  }

  .ant-carousel .slick-slide {
    text-align: center;
    background: transparent;
  }

  .image-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    background: transparent;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: transparent;
  }

  .arrow-wrapper {
    position: absolute;
    top: 50%;
    z-index: 2;
    display: flex;
    align-items: center;
    padding: 0 10px;
    background: transparent;
  }
`;

export const CarrouselImageWrapper = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
`;
